import { createSlice } from "@reduxjs/toolkit";
import {
  getOrders,
  getOrdersfromPagination,
  getCreditsData,
  getTrasactionsData,
  sendMsg,
  getOrderInfo,
  getSingleorderdata,
  getunseenPaymentsInTransactions,
} from "./dashBoardActions";

const initialState = {
  loading: false,
  orders: [],
  apiData: {
    sortColumn: "createdAt",
    sortDirection: "desc",
    filter: {},
  },

  unreadMsgs: [],
  unseenPayment: [],

  dummyapiData: {
    sortColumn: "createdAt",
    sortDirection: "desc",
    filter: {},
  },

  transactionApiData: {
    sortColumn: "requestTime",
    sortDirection: "desc",
    filter: {},
  },
  dummyTransactionApiData: {
    sortColumn: "requestTime",
    sortDirection: "desc",
    filter: {},
  },

  TotalTransactions: 0,
  pageNumber: 1,
  totalOrders: 0,
  totalCreditItems: 0,
  totalCredits: 0,
  optionObj: {
    openMore: false,
    anchorEl: false,
    placement: false,
    moreoptionDocument: {},
  },
  pagination: {},
  creditsTableData: [],
  creditsApiData: {
    sortColumn: "createdAt",
    sortDirection: "desc",
    filter: {},
  },
  dummycreditsApiData: {
    sortColumn: "createdAt",
    sortDirection: "desc",
    filter: {},
  },
  chatMessages: [],
  msg: "",

  msgNotification: {},
  paymentNotification: {},
  paymentOrderId: "",
};

const dashboardSlice = createSlice({
  name: "dashboardSlice",
  initialState,
  reducers: {
    sortColumnHandler: (state, { payload }) => {
      if (
        state.apiData.sortColumn === payload &&
        state.apiData.sortDirection === "asc"
      ) {
        state.apiData.sortDirection = "desc";
      } else if (
        state.apiData.sortColumn === payload &&
        state.apiData.sortDirection === "desc"
      ) {
        state.apiData.sortColumn = payload;
        state.apiData.sortDirection = "asc";
      } else {
        state.apiData.sortColumn = payload;
      }
    },
    filterHandler: (state, { payload }) => {
      state.apiData.filter = payload;
    },

    filterByTimestamp: (state, { payload }) => {
      state.apiData.filter.fromTime = payload;
    },

    dummyFilterDataHandler: (state, { payload }) => {
      const newData = { ...state.dummyapiData.filter };

      if (!newData[payload.filterId]) {
        newData[payload.filterId] = [];
      }

      if (newData[payload.filterId].includes(payload.id)) {
        newData[payload.filterId] = newData[payload.filterId].filter(
          (item) => item !== payload.id
        );
      } else {
        newData[payload.filterId].push(payload.id);
      }

      state.dummyapiData.filter = newData;
    },

    pageNumberhandler: (state, { payload }) => {
      if (payload === 0) {
        state.pageNumber = 1;
      } else {
        state.pageNumber = payload;
      }
    },

    setMoreOptionHandler: (state, { payload }) => {
      state.optionObj.moreoptionDocument = payload.rowData;

      state.optionObj.openMore = !state.optionObj.openMore;
      state.optionObj.anchorEl = payload.anchorEl;

      state.optionObj.placement = payload.newPlacement;
    },
    sortCreditsHandler: (state, { payload }) => {
      if (
        state.creditsApiData.sortColumn === payload &&
        state.creditsApiData.sortDirection === "asc"
      ) {
        state.creditsApiData.sortDirection = "desc";
      } else if (
        state.creditsApiData.sortColumn === payload &&
        state.creditsApiData.sortDirection === "desc"
      ) {
        state.creditsApiData.sortDirection = "asc";
      } else {
        state.creditsApiData.sortDirection = payload;
      }
    },

    dummycreditsfilterHandler: (state, { payload }) => {
      const newCreditData = { ...state.dummycreditsApiData.filter };

      if (!newCreditData[payload.filterId]) {
        newCreditData[payload.filterId] = [];
      }
      if (newCreditData[payload.filterId].includes(payload.id)) {
        newCreditData[payload.filterId] = newCreditData[
          payload.filterId
        ].filter((item) => item !== payload.id);
      } else {
        newCreditData[payload.filterId].push(payload.id);
      }

      state.dummycreditsApiData.filter = newCreditData;
    },

    creditsFiltersHandler: (state, { payload }) => {
      state.creditsApiData.filter = payload;
    },
    creditsFilterByTimestamp: (state, { payload }) => {
      state.creditsApiData.filter.fromTime = payload;
    },

    clearhistoryFiltersHandler: (state, { pyalod }) => {
      state.apiData.filter = {};
      state.dummyapiData.filter = {};
    },
    clearCreditsFiltersHandler: (state, { payload }) => {
      state.dummycreditsApiData.filter = {};
      state.creditsApiData.filter = {};
    },

    dummyTransactionfilterHandler: (state, { payload }) => {
      const newCreditData = { ...state.dummyTransactionApiData.filter };

      if (!newCreditData[payload.filterId]) {
        newCreditData[payload.filterId] = [];
      }
      if (newCreditData[payload.filterId].includes(payload.id)) {
        newCreditData[payload.filterId] = newCreditData[
          payload.filterId
        ].filter((item) => item !== payload.id);
      } else {
        newCreditData[payload.filterId].push(payload.id);
      }

      state.dummyTransactionApiData.filter = newCreditData;
    },

    TransactionFiltersHandler: (state, { payload }) => {
      state.transactionApiData.filter = payload;
    },
    sortTransctionColumnHandler: (state, { payload }) => {
      if (
        state.transactionApiData.sortColumn === payload &&
        state.transactionApiData.sortDirection === "asc"
      ) {
        state.transactionApiData.sortDirection = "desc";
      } else if (
        state.transactionApiData.sortColumn === payload &&
        state.transactionApiData.sortDirection === "desc"
      ) {
        state.transactionApiData.sortColumn = payload;
        state.transactionApiData.sortDirection = "asc";
      } else {
        state.transactionApiData.sortColumn = payload;
      }
    },
    TransactionTimeFilterHandler: (state, { payload }) => {
      state.transactionApiData.filter.fromTime = payload;
    },
    clearTransactionFilter: (state, { payload }) => {
      state.transactionApiData.filter = {};
      state.dummyTransactionApiData.filter = {};
    },
    calladdNewAdress: (state, { payload }) => {
      state.msg = payload;
    },
    closetheAddNewAdress: (state, { payload }) => {
      state.msg = "";
    },
    openmsgNotification: (state, { payload }) => {
      state.msgNotification = payload;
    },
    openPaymentNotification: (state, { payload }) => {
      state.paymentNotification = payload;
    },

    setPaymentOrderId: (state, { payload }) => {
      state.paymentOrderId = payload;
    },
  },

  extraReducers: (builder) => {
    // get total orders
    builder.addCase(getOrders.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getOrders.fulfilled, (state, { payload }) => {
      //
      state.loading = false;
      state.orders = payload?.response?.data?.data?.items;
      state.totalOrders = payload?.response?.data?.pagination?.total;

      //
    });
    builder.addCase(getOrders.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = true;
    });

    // get total orders
    builder.addCase(getunseenPaymentsInTransactions.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getunseenPaymentsInTransactions.fulfilled,
      (state, { payload }) => {
        //
        state.loading = false;

        const payments = [];

        for (let i = 0; i < payload?.response?.data?.data?.items?.length; i++) {
          if (payload?.response?.data?.data?.items[i].paymentURL) {
            // payments.push(payload?.response?.data?.data?.items[i])

            if (
              payload?.response?.data?.data?.items[i]?.paymentURL &&
              payload?.response?.data?.data?.items[i].status !== "SUCCESS"
            ) {
              payments.push({ ...payload?.response?.data?.data?.items[i] });
            }
          }
        }

        state.unseenPayment = payments;

        // state.orders = payload?.response?.data?.data?.items
        // state.totalOrders = payload?.response?.data?.pagination?.total

        //
      }
    );
    builder.addCase(
      getunseenPaymentsInTransactions.rejected,
      (state, { payload }) => {
        state.loading = false;
        state.error = true;
      }
    );

    // get total orders from pagination
    builder.addCase(getOrdersfromPagination.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getOrdersfromPagination.fulfilled, (state, { payload }) => {
      //
      state.loading = false;
      state.orders = payload?.response?.data?.data?.items;
      //
    });
    builder.addCase(getOrdersfromPagination.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = true;
    });

    // get total orders from pagination

    builder.addCase(getCreditsData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCreditsData.fulfilled, (state, { payload }) => {
      //
      state.loading = false;

      state.creditsTableData =
        payload?.response?.data?.data?.item?.creditsHistory;
      state.totalCreditItems = payload?.response?.data?.pagination?.total;
      state.totalCredits = payload?.response?.data?.data?.item?.totalCredits;
      state.totalOrders = payload?.response?.data?.pagination?.total;
      //
    });
    builder.addCase(getCreditsData.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = true;
    });

    builder.addCase(getTrasactionsData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTrasactionsData.fulfilled, (state, { payload }) => {
      //
      state.loading = false;

      // state.creditsTableData = payload?.response?.data?.data?.item?.creditsHistory
      state.totalOrders = payload?.response?.data?.pagination?.total;

      state.TotalTransactions = payload?.response?.data?.data?.count;
      // state.totalCredits = payload?.response?.data?.data?.item?.totalCredits
      //
    });
    builder.addCase(getTrasactionsData.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = true;
    });

    builder.addCase(getSingleorderdata.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSingleorderdata.fulfilled, (state, { payload }) => {
      //
      state.loading = false;
      state.chatMessages =
        payload?.response?.data?.data?.item?.orderInfo?.chats;
    });
    builder.addCase(getSingleorderdata.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = true;
    });

    builder.addCase(getOrderInfo.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getOrderInfo.fulfilled, (state, { payload }) => {
      //
      state.loading = false;
      state.chatMessages =
        payload?.response?.data?.data?.item?.orderInfo?.chats;
    });
    builder.addCase(getOrderInfo.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = true;
    });
  },
});

export default dashboardSlice.reducer;
export const {
  sortColumnHandler,
  closetheAddNewAdress,
  calladdNewAdress,
  sortTransctionColumnHandler,
  TransactionTimeFilterHandler,
  clearTransactionFilter,
  dummyTransactionfilterHandler,
  clearhistoryFiltersHandler,
  creditsFilterByTimestamp,
  clearCreditsFiltersHandler,
  filterByTimestamp,
  TransactionFiltersHandler,
  dummycreditsfilterHandler,
  creditsFiltersHandler,
  dummyFilterDataHandler,
  sortCreditsHandler,
  filterHandler,
  pageNumberhandler,
  setMoreOptionHandler,
  openPaymentNotification,
  openmsgNotification,
  setPaymentOrderId,
} = dashboardSlice.actions;

// export const { } = propertySlice.actions;
